<form [formGroup]="datiGeneraliForm" (ngSubmit)="save()" *ngIf="request">
  <app-dati-generali-fascicolo-common [request]="request" [fascicolo]="fascicolo" [inserimento]="inserimento" [datiGeneraliForm]="datiGeneraliForm" (changedFondoRischiState)="changedFondoRischiState()"></app-dati-generali-fascicolo-common>                                                                        
  <app-protocol-fascicolo-form [fascicolo]="fascicolo" (protocolDataChange)="onDataProtocol($event)" [dataView]="protocollo" /> 
  <div class="row">
    <div class="col-sm-6">
      <p>
        <label for="ogg-altrerisoluz-lbl">Oggetto</label>
        <input id="ogg-altrerisoluz-lbl" class="form-control" type="text" disabled="" [value]="fascicolo && fascicolo.oggetto ? fascicolo.oggetto : null">
      </p>
    </div>
  </div>

  <div class="row">
    <!--<div singleCheckBoxModInput class="col-sm-4"
         [labelInput]="'Risoluzione del rapporto di lavoro'" formControlName="risoluzioneRapportoDiLavoro"
         [objectReference]="request.fascicolo.risoluzioneRapportoDiLavoro"
         [(ngModel)]="request.fascicolo.risoluzioneRapportoDiLavoro"
         (onReturn)="request.fascicolo.risoluzioneRapportoDiLavoro = $event; changeRisoluzioneRapportoDiLavoro($event)"
         [mandatory]="true"></div>-->
    <div checkBoxRadio class="col-sm-4"
         formControlName="risoluzioneRapportoDiLavoro"
         idInput="risoluzioneRapportoDiLavoro"
         [labelInput]="'Risoluzione del rapporto di lavoro'"
         [objectReference]="request.fascicolo.risoluzioneRapportoDiLavoro"
         (onReturn)="request.fascicolo.risoluzioneRapportoDiLavoro = $event; changeRisoluzioneRapportoDiLavoro($event)"
         [mandatory]="true"></div>
    <div datePickerInput class="col-sm-4" [labelInput]="'Data risoluzione rapporto di lavoro'"
         formControlName="dataRisoluzioneRapportoDiLavoro"
         [control]="datiGeneraliForm.controls['dataRisoluzioneRapportoDiLavoro']"
         [(ngModel)]="request.fascicolo.dataRisoluzioneRapportoDiLavoro"
         [submitPending] ="!request.fascicolo.risoluzioneRapportoDiLavoro"
         [mandatory]="!!request.fascicolo.risoluzioneRapportoDiLavoro"
    ></div>

    <div comboModInput class="col-sm-4"
         [labelInput]="'Tipologia di risoluzione'" formControlName="tipoRisoluzione"
         [optionsCombo] ="tipoRisoluzioneOptions"
         [objectReference]="request.fascicolo.tipoRisoluzione"
         [(ngModel)]="request.fascicolo.tipoRisoluzione"
         (onReturn)="request.fascicolo.tipoRisoluzione = $event;"
         [mandatory]="!!request.fascicolo.risoluzioneRapportoDiLavoro"
         [submitPending] ="!request.fascicolo.risoluzioneRapportoDiLavoro"
    ></div>

  </div>

  <!-- <div class="row">

    <div checkBoxRadio class="col-sm-4"
         [labelInput]="'Recupero crediti'" idInput="recupero_crediti"
         formControlName="recuperoCrediti" [objectReference]="request.fascicolo.recuperoCrediti"
         (onReturn)="request.fascicolo.recuperoCrediti = $event"></div>

  </div> -->

  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12"
         [labelInput]="'Note'" formControlName="note"
         [(ngModel)]="request.fascicolo.note"></div>
  </div>

  <div>
    <h3 class="title1level">Campi personalizzati</h3>
        <app-fascicolo-metadata-form *ngIf="!fascicolo.id && fascicolo.tipoFascicolo.id"
          [tipoFascicolo]="fascicolo.tipoFascicolo.id"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
        <app-fascicolo-metadata-form *ngIf="fascicolo.id && fascicolo.tipoFascicolo.id"
          [fascicolo]="request.fascicolo"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
  </div>

  <div class="row">
    <p class="mandatory col-sm-12">
      <em>* Campi obbligatori</em>
    </p>
  </div>

  <div [ngClass]="minervaWizard ? 'wizard-buttons' : ''" class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" class="btn btn-outline-secondary btn-block"
              (click)="resetForm.emit()">Reset</button>
    </p>
    <p submitButton	class="col-sm-3 col-xs-6 col-sm-offset-6"
       [labelButton]="minervaWizard ? 'Prosegui' : 'Salva'" [disabled]="!datiGeneraliForm.valid || !metadataFormValid"></p>
  </div>
</form>
